import GradeDescription from './GradeDescription.vue'

export default GradeDescription
